export default "__VITE_ASSET__d098bbb8__"